import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  //title = 'FREE CalCulators';
}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/app.component.ts